module.exports = __webpack_public_path__ + "static/media/metropolis-medium.f4bca87f.otf";